module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li id="header_tile_container" class="photo_block" >\n    <div id="header_wrapper" class="' +
((__t = (getLayoutClass())) == null ? '' : __t) +
' ' +
((__t = (getButtonClass())) == null ? '' : __t) +
' ">\n        ';
 if (showTitle()) { ;
__p += '\n            <ul id="hashtag_holder" role="none"><li>' +
((__t = ( decode_utf8(getHeaderTitle()) )) == null ? '' : __t) +
'</li></ul>\n        ';
 } ;
__p += '\n        ';
 if (showDescription()) { ;
__p += '\n            <p id="description_holder">' +
((__t = ( isDefaultHeaderDescription() ? I18n.t('widget.header.description') : decode_utf8(getHeaderDescription()) )) == null ? '' : __t) +
'</p>\n        ';
 } ;
__p += '\n        ';
 if (hasTOS) { ;
__p += '\n        <button id="upload_now">' +
((__t = ( I18n.t('widget.upload_now') )) == null ? '' : __t) +
'</button>\n        ';
 } ;
__p += '\n        ';
 if (isViewGallery()) { ;
__p += '\n            <a href="' +
((__t = (getViewGalleryUrl())) == null ? '' : __t) +
'" target="_blank" id="view_gallery" title="' +
((__t = ( I18n.t('common.open_window') )) == null ? '' : __t) +
'">' +
((__t = ( isDefaultViewGalleryText() ? I18n.t('widget.header.view_gallery') : decode_utf8(getViewGalleryText()) )) == null ? '' : __t) +
'</a>\n        ';
 } ;
__p += '\n        <p class="screen_reader_only">' +
((__t = ( I18n.t('widget.screen_reader_only.uploader.title') )) == null ? '' : __t) +
'</p>\n    </div>\n</li>\n';

}
return __p
}